import './CTGY_SS.scss';
import {PageManager} from '@mvps-genesis/bootstrap';
import {Search} from 'custom-extensions/searchspring';

export default class CTGY_SS extends PageManager {

	constructor (pageContext) {

		super(pageContext);

		/**
		 * Skip Searchspring if `CTGY_STORE`
		 */
		if (this.pageContext.Page_Code === 'CTGY_STORE') {
			return;
		}

		/**
		 * Initialize Search UI
		 */
		Search.create({
			categoryCode: pageContext.Category_Code,
			categoryField: typeof window.mivaJS.Searchspring_Category_Background_Filters === 'undefined' ? 'category_codes' : null,
			defaultSearchParams: {
				resultsPerPage: 60
			},
			filters: window?.mivaJS?.Searchspring_Category_Background_Filters?.map(([field, value]) => ({field, value})) ?? [],
			query: pageContext.Search,
			siteId: window.SS_SITE_ID
		});

	}

	onReady () {
		this.splitCategoryFooter();
	}

	splitCategoryFooter () {
		const readMoreElem = document.querySelector('.g-read-more');

		if (!readMoreElem) {
			return;
		}

		const visibleContent = readMoreElem.querySelector('.g-read-more__visible');
		const hiddenContent = readMoreElem.querySelector('.g-read-more__hidden');

		if (!visibleContent || !hiddenContent) {
			return;
		}

		const childElemsArr = [];
		const childElems = visibleContent.childNodes;

		for (const childElem of childElems) {
			if (childElem.outerHTML) {
				childElemsArr.push(childElem.outerHTML);
			} else if (childElem.textContent !== '\n') {
				childElemsArr.push(childElem.textContent);
			}
		}

		const childElemsArrLen = childElemsArr.length;

		if (childElemsArrLen <= 2) {
			const readMoreOverlay = readMoreElem.querySelector('.g-read-more__overlay');
			const readMoreToggle = readMoreElem.querySelector('.js-read-more-toggle');

			readMoreOverlay.style.display = 'none';
			readMoreToggle.style.display = 'none';

			return;
		}

		visibleContent.innerHTML = '';

		for (let i = 0; i <= 2; i++) {
			visibleContent.innerHTML += childElemsArr[i];
		}

		visibleContent.innerHTML += childElemsArr[childElemsArr.length - 1];

		for (let i = 3; i < childElemsArrLen; i++) {
			hiddenContent.innerHTML += childElemsArr[i];
		}
	}

};
